import mutationTypeFilter from 'app/filters/loggerMutationType'

export default class LoggerMutationType {

    static CREATED = 'CREATED';
    static AVAILABLE = 'AVAILABLE';
    static DEPLOYED = 'DEPLOYED';
    static RETURNING = 'RETURNING';
    static REPAIR_PENDING = 'REPAIR_PENDING';
    static REPAIR_ACTIVE = 'REPAIR_ACTIVE';
    static WRITTEN_OF = 'WRITTEN_OF';

    static options(){

        return {
            'CREATED': mutationTypeFilter(LoggerMutationType.CREATED),
            'AVAILABLE': mutationTypeFilter(LoggerMutationType.AVAILABLE),
            'DEPLOYED': mutationTypeFilter(LoggerMutationType.DEPLOYED),
            'RETURNING': mutationTypeFilter(LoggerMutationType.RETURNING),
            'REPAIR_PENDING': mutationTypeFilter(LoggerMutationType.REPAIR_PENDING),
            'REPAIR_ACTIVE': mutationTypeFilter(LoggerMutationType.REPAIR_ACTIVE),
            'WRITTEN_OF': mutationTypeFilter(LoggerMutationType.WRITTEN_OF),
        };
    }
}